export default __webpack_public_path__ + "static/outer_top-baa2629f5589124b4dfe8300644d4b3c.png";